define("settings/templates/groups/trade", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tAC--page">
    <div class="o--page--scroll">
      {{! Header }}
      <div class="cHN--wrapper">
        <div class="cHN--container">
          <div class="cHN--logo">
            <LinkToExternal @model={{this.lastGroup.slug}} @route="cluster.schedule.calendar">
              <span class="img--logo"></span>
            </LinkToExternal>
          </div>
          <h3 class="cHN--title">{{t "account.social_sets.trade.header"}}</h3>
          <div class="u--float--right u--m__t__xs">
            <LinkTo @route="groups.index" class="o--btn o--btn--outline u--m__r">
              {{t "shared_words.cancel"}}
            </LinkTo>
            <Shared::Ui::Button
              @onClick={{perform this.saveChanges}}
              @text={{t "shared_phrases.save_changes"}}
              @variant="primary"
            />
          </div>
        </div>
      </div>
      {{! Body }}
      <div class="o--container tAC--container">
        <div class="o--card tAC--card tAC--card--move">
          <div class="o--cardBody">
            <p class="u--text--md u--m__b__lg u--m__t__md">{{t "account.social_sets.trade.description"}}</p>
  
            {{! Organization Table }}
            <table class="o--table tAC--table">
              {{! Table Head }}
              <thead>
                <tr>
                  <th style="width:159px;">{{t "account.groups.table.group_name"}}</th>
                  <th style="width:420px;">
                    {{t "account.groups.table.social_identities"}}
                    <span {{on "click" (toggle-action "showInfo" this)}}>
                      {{svg-jar "info" class="o--icon--xs"}}
                    </span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {{#each this.temporaryGroups as |group|}}
                  <Groups::GroupCover
                    @editable={{true}}
                    @group={{group}}
                    @showProfileList={{true}}
                    @trackGroupTrade={{this.trackGroupTrade}}
                    @trackProfileTrade={{this.trackProfileTrade}}
                  />
                {{/each}}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  {{#if this.showInfo}}
    <Shared::SocialIdentity::Info @handleClose={{toggle-action "showInfo" this}} />
  {{/if}}
  */
  {
    "id": "r9644LA1",
    "block": "[[[10,\"section\"],[14,0,\"tAC--page\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--page--scroll\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"cHN--wrapper\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cHN--container\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cHN--logo\"],[12],[1,\"\\n          \"],[8,[39,0],null,[[\"@model\",\"@route\"],[[30,0,[\"lastGroup\",\"slug\"]],\"cluster.schedule.calendar\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,1],[14,0,\"img--logo\"],[12],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"h3\"],[14,0,\"cHN--title\"],[12],[1,[28,[35,1],[\"account.social_sets.trade.header\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--float--right u--m__t__xs\"],[12],[1,\"\\n          \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline u--m__r\"]],[[\"@route\"],[\"groups.index\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.cancel\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[39,3],null,[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,4],[[30,0,[\"saveChanges\"]]],null],[28,[37,1],[\"shared_phrases.save_changes\"],null],\"primary\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"o--container tAC--container\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--card tAC--card tAC--card--move\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--cardBody\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--md u--m__b__lg u--m__t__md\"],[12],[1,[28,[35,1],[\"account.social_sets.trade.description\"],null]],[13],[1,\"\\n\\n\"],[1,\"          \"],[10,\"table\"],[14,0,\"o--table tAC--table\"],[12],[1,\"\\n\"],[1,\"            \"],[10,\"thead\"],[12],[1,\"\\n              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"th\"],[14,5,\"width:159px;\"],[12],[1,[28,[35,1],[\"account.groups.table.group_name\"],null]],[13],[1,\"\\n                \"],[10,\"th\"],[14,5,\"width:420px;\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"account.groups.table.social_identities\"],null]],[1,\"\\n                  \"],[11,1],[4,[38,5],[\"click\",[28,[37,6],[\"showInfo\",[30,0]],null]],null],[12],[1,\"\\n                    \"],[1,[28,[35,7],[\"info\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"th\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,0,[\"temporaryGroups\"]]],null]],null],null,[[[1,\"                \"],[8,[39,10],null,[[\"@editable\",\"@group\",\"@showProfileList\",\"@trackGroupTrade\",\"@trackProfileTrade\"],[true,[30,1],true,[30,0,[\"trackGroupTrade\"]],[30,0,[\"trackProfileTrade\"]]]],null],[1,\"\\n\"]],[1]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showInfo\"]],[[[1,\"  \"],[8,[39,12],null,[[\"@handleClose\"],[[28,[37,6],[\"showInfo\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"group\"],false,[\"link-to-external\",\"t\",\"link-to\",\"shared/ui/button\",\"perform\",\"on\",\"toggle-action\",\"svg-jar\",\"each\",\"-track-array\",\"groups/group-cover\",\"if\",\"shared/social-identity/info\"]]",
    "moduleName": "settings/templates/groups/trade.hbs",
    "isStrictMode": false
  });
});